module.exports = __webpack_public_path__ + "img/vslogo.14b872e0.svg";